<template>
<div class="evan-cell">
  <div class="evan-cell_columns">
    <div  class="evan-cell_field" @click="clickCell" style="justify-content: space-between;width: 100%">
      <i v-if="titlePreIcon&&!$slots.preIcon" :class="`iconfont ${titlePreIcon}`"></i>
      <slot name="preIcon"></slot>
      <div v-if="!$slots.title">{{ title }}</div>
      <slot name="title"></slot>
      <div v-if="$slots.titleAppend||$slots.appendIcon||titleAppendIcon" style="display: flex;flex-direction: row;justify-content: flex-end;align-items: center;gap: .3em">
        <slot name="titleAppend"></slot>
        <i v-if="titleAppendIcon&&!$slots.appendIcon" :class="`iconfont ${titleAppendIcon}`"></i>
        <slot name="appendIcon"></slot>
      </div>
    </div>
    <div v-if="$slots.bottom" style="border-top: 1px dashed var(--border-color);width: 100%;padding: .2em 0">
      <slot name="bottom"></slot>
    </div>
    <slot name="footer" class="slot-footer"></slot>
  </div>
</div>
</template>

<script>
export default {
  name: "EvanCell",
  props: {
    titlePreIcon: {
      type: String,
      default: '',
    },
    titleAppendIcon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    }
  },
  methods:{
    clickCell() {
      this.$emit('click');
    },
  }
}
</script>

<style lang="scss">
.evan-cell {
  width: 100%;
  outline: none;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: .5em;
  padding: .5em 1em;
  border-radius: .5em;
  border: 1px solid var(--border-color);

  background-color: var(--input-bg);


}

.evan-cell_columns {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: .3em;
  width: 100%;
}

.evan-cell_field {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: .3em;
}

</style>
